import {
	BUTTON_GHOST,
	BUTTON_PRIMARY,
	BUTTON_SECONDARY,
} from "./surfaceClasses";

export type ButtonVariant = "primary" | "secondary" | "ghost";

/**
 * The variant name a call site asks for, and the surface it gets. Shared by
 * Button and ButtonLink so an action that navigates cannot end up looking
 * different from one that does not.
 */
export const BUTTON_VARIANTS: Readonly<Record<ButtonVariant, string>> = {
	primary: BUTTON_PRIMARY,
	secondary: BUTTON_SECONDARY,
	ghost: BUTTON_GHOST,
};
